import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const WHATSAPP_NUMBER = '601165337469';

const MESSAGES = {
  en: 'Hi, I would like to join the waitlist for VERSE Clinic.',
  zh: '您好，我希望加入 VERSE Clinic 的专属候补名单，了解更多长寿与再生医学方案。',
};

export const FloatingContact = () => {
  const { i18n } = useTranslation();
  const [hovered, setHovered] = useState(false);
  const isZh = i18n.language?.startsWith('zh');
  const msg = encodeURIComponent(isZh ? MESSAGES.zh : MESSAGES.en);
  const label = isZh ? '联系我们' : 'Chat with us';

  return (
    <a
      data-testid="floating-contact-button"
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-5 sm:right-6 z-[90] flex items-center gap-2.5 rounded-full transition-all duration-200 no-underline"
      style={{
        height: '44px',
        padding: '0 14px',
        backgroundColor: hovered ? 'rgba(214,168,74,0.25)' : 'rgba(214,168,74,0.12)',
        border: `1px solid ${hovered ? 'rgba(214,168,74,0.5)' : 'rgba(214,168,74,0.3)'}`,
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"
          style={{ fill: 'var(--vc-gold)' }}
        />
        <path
          d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.955 9.955 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 01-4.28-1.238l-.307-.184-2.87.853.853-2.87-.184-.307A8 8 0 1112 20z"
          style={{ fill: 'var(--vc-gold)' }}
        />
      </svg>
      <span
        className="text-xs sm:text-sm font-medium whitespace-nowrap hidden lg:inline"
        style={{ color: 'var(--vc-gold)', fontFamily: 'Inter, sans-serif' }}
      >
        {label}
      </span>
    </a>
  );
};
